import gql from 'graphql-tag'

export const user = {
  fragment: gql`
    fragment user on Factura {
      user {
        id
        username
        fullname
        email
      }
    }
  `
}

export const general = {
  fragment: gql`
    fragment general on Factura {
      id
      createdAt
      documento {
        id
        value
        annotation
      }
      consecutivo
      local {
        id
        numero
      }
      terminal {
        id
        numero
      }
      situacionComprobante {
        id
        value
        annotation
      }
      clave
      codigoActividad {
        id
        value
        annotation
      }
      numeroConsecutivo
      fechaEmision
      estadoDocumento {
        id
        value
        annotation
      }
    }
  `
}

export const emisor = {
  fragment: gql`
    fragment emisor on Factura {
      emisor {
        id
        nombre
        identificacion {
          tipo {
            id
            value
            annotation
          }
          numero
        }
        nombreComercial
        ubicacion {
          provincia {
            id
            value
            annotation
          }
          canton {
            id
            codigo
            annotation
          }
          distrito {
            id
            codigo
            annotation
          }
          otrasSenas
        }
        telefono {
          codigoPais
          numTelefono
        }
        correoElectronico

        cuentaContable
      }
    }
  `
}

export const receptor = {
  fragment: gql`
    fragment receptor on Factura {
      receptor {
        id
        nombre
        identificacion {
          tipo {
            id
            value
            annotation
          }
          numero
        }
        identificacionExtranjero
        # ubicacion {
        #   provincia {
        #     value
        #   }
        #   canton {
        #     codigo
        #   }
        #   distrito {
        #     codigo
        #   }
        #   otrasSenas
        # }
        # telefono {
        #   codigoPais
        #   numTelefono
        # }
        correoElectronico

        cuentaContable
      }
    }
  `
}

export const condiciones = {
  fragment: gql`
    fragment condiciones on Factura {
      condicionVenta {
        id
        annotation
      }
      plazoCredito
      pagaCon
    }
  `
}

export const detalleServicio = {
  fragment: gql`
    fragment detalleServicio on Factura {
      detalleServicio {
        lineaDetalle {
          numeroLinea
          # TODO: mostrar el item JIT facturado.
          item {
            _id
            nombre
          }
          clasificacion
          codigoCABYS
          # codigoComercial {
          #   tipo {
          #     id
          #     value
          #     annotation
          #   }
          #   codigo
          # }
          cantidad
          conversion
          cantidadConv
          unidadMedida {
            id
            annotation
          }
          unidadMedidaComercial
          detalle
          precioUnitario
          montoTotal
          descuento {
            montoDescuento
            naturalezaDescuento
            codigoDescuento
          }
          subtotal
          baseImponible
          ...impuesto
          impuestoNeto
          montoTotalLinea

          cuentaContablePorCobrar {
            _id
          }
          cuentaContablePorPagar {
            _id
          }
        }
      }
    }
  `
}

export const impuesto = {
  fragment: gql`
    fragment impuesto on Detalle {
      impuesto {
        codigo {
          id
          value
          annotation
        }
        codigoTarifaIVA {
          id
          value
          annotation
        }
        tarifa
        factorIVA
        monto
        # montoExportacion
        exoneracion {
          tipoDocumentoEX1 {
            id
            annotation
            value
          }
          numeroDocumento
          articulo
          inciso
          nombreInstitucion
          fechaEmisionEX
          tarifaExonerada
          montoExoneracion
        }
      }
    }
  `
}

export const otrosCargos = {
  fragment: gql`
    fragment otrosCargos on Factura {
      otrosCargos {
        tipoDocumentoOC {
          id
          value
          annotation
        }
        # numeroIdentidadTercero no aplica en esta version
        # nombreTercero no aplica en esta version
        detalle
        porcentajeOC
        montoCargo
      }
    }
  `
}

export const resumenFactura = {
  fragment: gql`
    fragment resumenFactura on Factura {
      resumenFactura {
        codigoTipoMoneda {
          codigoMoneda {
            id
            value
            simbolo
          }
          tipoCambio
        }
        medioPago {
          id
          tipoMedioPago
          annotation
          totalMedioPago
        }
        totalServGravados
        totalServExentos
        totalServExonerado
        totalMercanciasGravadas
        totalMercanciasExentas
        totalMercExonerada
        totalGravado
        totalExento
        totalExonerado
        totalVenta
        totalDescuentos
        totalVentaNeta
        totalImpuesto
        totalIVADevuelto
        totalOtrosCargos
        totalComprobante
      }
    }
  `
}

export const informacionReferencia = {
  fragment: gql`
    fragment informacionReferencia on Factura {
      informacionReferencia {
        tipoDocIR {
          value
          annotation
        }
        numero
        fechaEmisionIR
        codigo {
          value
          annotation
        }
        razon
      }
    }
  `
}

export const otros = {
  fragment: gql`
    fragment otros on Factura {
      otros {
        otroTexto
        otroContenido
      }
    }
  `
}
